var map = {
	"./authentication/authentication.module": [
		"./src/theme/default/admin/authentication/authentication.module.ts",
		"authentication-authentication-module"
	],
	"./catalog/catalog.module": [
		"./src/theme/default/admin/catalog/catalog.module.ts",
		"default~catalog-catalog-module~components-brand-brand-module~components-product-product-module",
		"default~catalog-catalog-module~components-categories-categories-module~components-product-product-mo~98489240",
		"common",
		"catalog-catalog-module"
	],
	"./cms/cms.module": [
		"./src/theme/default/admin/cms/cms.module.ts",
		"cms-cms-module"
	],
	"./components/banner/banner.module": [
		"./src/theme/default/admin/cms/components/banner/banner.module.ts",
		"components-banner-banner-module"
	],
	"./components/brand/brand.module": [
		"./src/theme/default/admin/catalog/components/brand/brand.module.ts",
		"default~catalog-catalog-module~components-brand-brand-module~components-product-product-module",
		"default~components-brand-brand-module~components-product-product-module",
		"common",
		"components-brand-brand-module"
	],
	"./components/categories/categories.module": [
		"./src/theme/default/admin/catalog/components/categories/categories.module.ts",
		"default~catalog-catalog-module~components-categories-categories-module~components-product-product-mo~98489240",
		"default~components-categories-categories-module~components-product-product-module",
		"common",
		"components-categories-categories-module"
	],
	"./components/customer/customer.module": [
		"./src/theme/default/admin/customers/components/customer/customer.module.ts",
		"default~components-customer-customer-module~components-grupo-grupo-module~customers-customers-module",
		"default~components-customer-customer-module~components-grupo-grupo-module",
		"common",
		"components-customer-customer-module"
	],
	"./components/generalsettings/generalsettings.module": [
		"./src/theme/default/admin/settings/components/generalsettings/generalsettings.module.ts",
		"default~components-generalsettings-generalsettings-module~settings-settings-module~zone-zone-module",
		"common",
		"components-generalsettings-generalsettings-module"
	],
	"./components/grupo/grupo.module": [
		"./src/theme/default/admin/customers/components/grupo/grupo.module.ts",
		"default~components-customer-customer-module~components-grupo-grupo-module~customers-customers-module",
		"default~components-customer-customer-module~components-grupo-grupo-module",
		"common",
		"components-grupo-grupo-module"
	],
	"./components/localizations/localization.module": [
		"./src/theme/default/admin/settings/components/localizations/localization.module.ts",
		"components-localizations-localization-module"
	],
	"./components/orders/orders.module": [
		"./src/theme/default/admin/sales/components/orders/orders.module.ts",
		"common",
		"components-orders-orders-module"
	],
	"./components/pages/pages.module": [
		"./src/theme/default/admin/cms/components/pages/pages.module.ts",
		"components-pages-pages-module"
	],
	"./components/personalize/personalize.module": [
		"./src/theme/default/admin/settings/components/personalize/personalize.module.ts",
		"components-personalize-personalize-module"
	],
	"./components/product/product.module": [
		"./src/theme/default/admin/catalog/components/product/product.module.ts",
		"default~catalog-catalog-module~components-brand-brand-module~components-product-product-module",
		"default~catalog-catalog-module~components-categories-categories-module~components-product-product-mo~98489240",
		"default~components-categories-categories-module~components-product-product-module",
		"default~components-brand-brand-module~components-product-product-module",
		"common",
		"components-product-product-module"
	],
	"./components/role/role.module": [
		"./src/theme/default/admin/settings/components/role/role.module.ts",
		"common",
		"components-role-role-module"
	],
	"./components/sitesettings/sitesettings.module": [
		"./src/theme/default/admin/settings/components/sitesettings/sitesettings.module.ts",
		"components-sitesettings-sitesettings-module"
	],
	"./components/user/user.module": [
		"./src/theme/default/admin/settings/components/user/user.module.ts",
		"common",
		"components-user-user-module"
	],
	"./countries/countries.module": [
		"./src/theme/default/admin/settings/components/localizations/countries/countries.module.ts",
		"common",
		"countries-countries-module"
	],
	"./customers/customers.module": [
		"./src/theme/default/admin/customers/customers.module.ts",
		"default~components-customer-customer-module~components-grupo-grupo-module~customers-customers-module",
		"common",
		"customers-customers-module"
	],
	"./dashboard/dashboard.module": [
		"./src/theme/default/admin/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./emailtemplate/emailtemplate.module": [
		"./src/theme/default/admin/settings/components/localizations/emailtemplate/emailtemplate.module.ts",
		"emailtemplate-emailtemplate-module"
	],
	"./error/error.module": [
		"./src/theme/default/admin/error/error.module.ts",
		"error-error-module"
	],
	"./layout/changepassword/changepassword.module": [
		"./src/theme/default/admin/layout/changepassword/changepassword.module.ts",
		"layout-changepassword-changepassword-module"
	],
	"./order/personalize-order.module": [
		"./src/theme/default/admin/settings/components/personalize/order/personalize-order.module.ts",
		"order-personalize-order-module"
	],
	"./orderstatus/orderstatus.module": [
		"./src/theme/default/admin/settings/components/localizations/orderstatus/orderstatus.module.ts",
		"orderstatus-orderstatus-module"
	],
	"./product/personalize-product.module": [
		"./src/theme/default/admin/settings/components/personalize/product/personalize-product.module.ts",
		"product-personalize-product-module"
	],
	"./sales/sales.module": [
		"./src/theme/default/admin/sales/sales.module.ts",
		"sales-sales-module"
	],
	"./seo/seo.module": [
		"./src/theme/default/admin/settings/components/sitesettings/seo/seo.module.ts",
		"seo-seo-module"
	],
	"./settings/settings.module": [
		"./src/theme/default/admin/settings/settings.module.ts",
		"default~components-generalsettings-generalsettings-module~settings-settings-module~zone-zone-module",
		"common",
		"settings-settings-module"
	],
	"./social/social.module": [
		"./src/theme/default/admin/settings/components/sitesettings/social/social.module.ts",
		"social-social-module"
	],
	"./stockstatus/stockstatus.module": [
		"./src/theme/default/admin/settings/components/localizations/stockstatus/stockstatus.module.ts",
		"stockstatus-stockstatus-module"
	],
	"./zone/zone.module": [
		"./src/theme/default/admin/settings/components/localizations/zone/zone.module.ts",
		"default~components-generalsettings-generalsettings-module~settings-settings-module~zone-zone-module",
		"common",
		"zone-zone-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;